<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1"><div class="Basic-Graphics-Frame _idGenObjectStyle-Disabled" id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" src="image/dedication.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-5-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer006">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-5-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-6-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-7-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> His and Hers Temperature Zones. Please, someone, go out and invent that.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-8-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> I like to talk to people who don’t have kids. It’s as close as I come to speaking a foreign language.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-9-14.png"/></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoYelling_EPUB-10.vue?ec37adce